import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7100e0a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "matchSchedule" }
const _hoisted_2 = { class: "matchScheduleFull" }
const _hoisted_3 = { class: "center display-2" }
const _hoisted_4 = { class: "matchScheduleMobile" }
const _hoisted_5 = { class: "center display-5" }
const _hoisted_6 = {
  key: 0,
  class: "layout gutter--md"
}
const _hoisted_7 = { class: "searchControls row row align--center justify--space-around mb-4" }
const _hoisted_8 = { class: "md2 flex mobile sm1" }
const _hoisted_9 = { class: "md3 flex xs12 sm4" }
const _hoisted_10 = {
  key: 1,
  class: "layout gutter--xl"
}
const _hoisted_11 = { class: "row justify--center tournamentContainer" }
const _hoisted_12 = {
  class: "blockSpace",
  style: {"font-size":"x-large"}
}
const _hoisted_13 = { class: "blockSpace" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"accordion-header-name\" data-v-7100e0a1><h4 class=\"column\" data-v-7100e0a1>KAMP NR</h4><h4 class=\"column\" data-v-7100e0a1>HJEMMEHOLD</h4><h4 class=\"column\" data-v-7100e0a1>UDEHOLD</h4><h4 class=\"column\" data-v-7100e0a1>RESULTAT</h4></div>", 1)
const _hoisted_15 = { class: "accordion-header" }
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "column" }
const _hoisted_19 = { class: "column with-actions" }
const _hoisted_20 = { class: "matchScheduleFull" }
const _hoisted_21 = { class: "va-table-responsive blockSpace" }
const _hoisted_22 = {
  class: "va-table--striped va-table",
  style: {"width":"100%"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"34%"} }, "HomePlayer"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"34%"} }, "AwayPlayer"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Resultat"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} })
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_25 = { class: "matchScheduleMobile" }
const _hoisted_26 = { class: "row align--baseline" }
const _hoisted_27 = { class: "center" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--space-around" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Ingen kampe ser ud til at være startet endnu.")
    ])
  ])
], -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, "Livekampe " + _toDisplayString(_ctx.seasonString), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h5", _hoisted_5, "Livekampe " + _toDisplayString(_ctx.seasonString), 1)
    ]),
    (Object.keys(_ctx.forFilterMatchData).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_va_button, {
                class: "btn",
                color: "#b4003a",
                rounded: false,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_icon, {
                    class: "reset",
                    name: "autorenew"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_va_select, {
                label: "Filtrer efter klub",
                modelValue: _ctx.filterByClubValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterByClubValue) = $event)),
                options: _ctx.filterByClubOptions,
                searchable: "",
                bordered: ""
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (Object.keys(_ctx.liveMatchData).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.liveMatchData, (mainValue, mainName, mainIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: mainIndex,
                style: {"width":"100%"}
              }, [
                _createElementVNode("h2", _hoisted_12, _toDisplayString(mainName), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainValue, (value, name, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("h4", _hoisted_13, _toDisplayString(name), 1),
                    _hoisted_14,
                    _createVNode(_component_va_accordion, {
                      multiple: "",
                      id: "liveMatchAccordion",
                      class: "blockSpace"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (teamData, index) => {
                          return (_openBlock(), _createBlock(_component_va_collapse, { key: index }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, _toDisplayString(teamData.kampnr), 1),
                                _createElementVNode("div", _hoisted_17, _toDisplayString(teamData.homeTeamName), 1),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(teamData.awayTeamName), 1),
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", null, _toDisplayString(teamData.homeTeamResult) + " - " + _toDisplayString(teamData.awayTeamResult), 1),
                                  _createVNode(_component_va_icon, { name: "more_horiz" })
                                ])
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("table", _hoisted_22, [
                                    _hoisted_23,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamData.matches, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                          _createElementVNode("td", null, _toDisplayString(item.homePlayerName), 1),
                                          _createElementVNode("td", null, _toDisplayString(item.awayPlayerName), 1),
                                          _createElementVNode("td", null, _toDisplayString(item.homeTotalwins) + " - " + _toDisplayString(item.awayTotalwins), 1),
                                          _createElementVNode("td", null, [
                                            _createVNode(_component_router_link, {
                                              to: ('/turnering/turneringslivekampe/' + Number(item.id).toString())
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_24
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamData.matches, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "flex sm6 xs12",
                                      key: item
                                    }, [
                                      _createVNode(_component_va_card, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_va_card_content, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", null, "HomePlayer: " + _toDisplayString(item.homePlayerName), 1),
                                              _createElementVNode("p", null, "AwayPlayer: " + _toDisplayString(item.awayPlayerName), 1),
                                              _createElementVNode("p", null, "Resultat: " + _toDisplayString(item.homeTotalwins) + " - " + _toDisplayString(item.awayTotalwins), 1),
                                              _createElementVNode("p", _hoisted_27, [
                                                _createVNode(_component_router_link, {
                                                  to: ('/turnering/turneringslivekampe/' + Number(item.id).toString())
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_28
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
  ]))
}